import { Box, Typography } from '@mui/material'

import MobileAppButtons from '@ecm/ui/component/mobilePage/MobileAppButtons'
import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import Color from '@ecm/ui/element/Color'
import MainContainer from '@ecm/ui/element/MainContainer'

import illustration from '/public/images/illustration/check-notifications.svg'

const DownloadApp = () => (
  <MainContainer
    sx={{
      alignItems: 'center',
      display: 'grid',
      gap: '4em',
      gridTemplateColumns: { md: '1fr 1fr', xs: '1fr' },
      py: { md: '7.5em', xs: '3.5em' },
    }}
  >
    <CloudflareImage src={illustration} />

    <Box order={{ md: 'unset', xs: -1 }} textAlign={{ md: 'left', xs: 'center' }}>
      <Typography variant="h3">Start managing your postal mail the easy way!</Typography>
      <Typography variant="p2" color={Color.saint.lighter}>
        <b>Download the Earth Class Mail mobile app</b> on your preferred platform.
      </Typography>

      <MobileAppButtons justifyContent={{ md: 'start', xs: 'center' }} />
    </Box>
  </MainContainer>
)

export default DownloadApp
